<div
  class="connectors-description"
  *ngIf="
    (isLoading$ | async) === false && policyModel.platform !== 'salesforce' && policyModel.platform !== 'service_now'
  "
>
  {{ 'policyPage.config.connectorsContent.description' | labelsProvider }}
</div>
<div class="button-and-divider">
  <app-effective-policy-settings-button
    class="policy-field-effective-policy-settings-button"
    [effectivePolicySetting]="EffectivePolicySettingEnum.connectorList"
    [platform]="integrationModel.platform"
  >
  </app-effective-policy-settings-button>

  <div
    class="divider"
    *ngIf="
      (isLoading$ | async) === false && policyModel.platform !== 'salesforce' && policyModel.platform !== 'service_now'
    "
  ></div>
</div>

<div
  class="connectors"
  *ngIf="
    (isLoading$ | async) === false && policyModel.platform !== 'salesforce' && policyModel.platform !== 'service_now'
  "
>
  <div class="connectors-input-boxs">
    <app-autocomplete-search
      class="connectors-autocomplete-search-box"
      placeholder="Search..."
      (autocompleteOnChange)="connectorSearched($event)"
      [values]="connectorsDisplayNamesForSearch"
      [resetSearchBox$]="resetSearchBoxBehavioralSubject$"
    >
    </app-autocomplete-search>
    <app-select
      class="connectors-categories-box"
      placeHolder="Select"
      [options]="connectorCategorySelectOptions"
      [selectOptionIndexObservable]="injectCategoryOptionIndex"
      [optionSelected]="selectedCategoryOption"
      (optionOnSelection)="onCategorySelection($event)"
    >
    </app-select>
  </div>

  <div class="connectors-table">
    <div class="connectors-table-body connectors-table-body-scrollable">
      <div class="connector-row-checkbox" *ngFor="let connector of connectorsToPresent">
        <div
          class="connector-row-checkbox-text"
          (click)="editable ? connectorSelected(connector) : $event.preventDefault()"
        >
          <mat-checkbox color="primary" [checked]="selectedConnectorIdsToPresent.indexOf(connector.id) > -1">
          </mat-checkbox>
          <div class="connector-row-checkbox-text-title">
            {{ connector.displayName }}
          </div>
        </div>
      </div>
    </div>
    <app-table-pagination
      [totalNumberOfElements]="searchInProgress ? searchedConnectors.length : allConnectors.length"
      [numberOfElementsChangedBehavioralSubject$]="updateNumberOfConnectorsBehavioralSubject$"
      [resetPagesReplaySubject$]="resetConnectorsPages$"
      (paginationNumberOnClick)="pageNumberGotUpdated($event)"
    >
    </app-table-pagination>
  </div>

  <app-form-footer
    *ngIf="editable"
    [changesWereDone]="changesWereDone"
    (resetChanges)="resetForm()"
    (saveChanges)="updatePolicyConfig()"
    (cancelSettings)="cancelSettings()"
  ></app-form-footer>
</div>

<div *ngIf="isLoading$ | async" class="connectors-spinner">
  <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>

<app-coming-soon
  class="connectors-spinner"
  *ngIf="policyModel.platform === 'salesforce' || policyModel.platform === 'service_now'"
>
</app-coming-soon>
